import axios from "axios";

const ssoHttp = axios.create({
  baseURL:
    process.env.REACT_APP_SSO_API_URL ||
    "https://sso.kesp.cl/sso/rest",
  withCredentials: true,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default ssoHttp;
